import { Subject } from "rx";

import { TRACK_CLICK } from "../const/actions";

const trackingActions = new Subject();

const trackClick = (category, action, label) => trackingActions.onNext({
  action, category, label, type: TRACK_CLICK
});

export {
  trackingActions,
  trackClick
};



// WEBPACK FOOTER //
// ./actions/TrackingActionCreators.js